import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/espp-calculator',
  component: () => import('../../routes/EsppCalculator.svelte'),
  card: {
    id: 'espp-calculator',
    title: 'ESPP Calculator',
    description: 'Calculate your Employee Stock Purchase Plan (ESPP) tax liability and net benefit from the discounted stock purchase.',
    icon: 'trending_up',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/espp-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'ESPP Calculator – Employee Stock Purchase Plan Tax & Profit Calculator',
    description: 'Free ESPP calculator to calculate your Employee Stock Purchase Plan compensation income, tax liability, and net financial benefit. Supports short-term and long-term holding period analysis.',
  },
};

export default meta;